var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19651",
    "data-name": "Grupo 19651",
    transform: "translate(-1580 -1040.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19650",
    "data-name": "Grupo 19650",
    transform: "translate(145.188 2384.813) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18036",
    "data-name": "Grupo 18036",
    transform: "translate(146.145 149.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_44770",
    "data-name": "Rect\\xE1ngulo 44770",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(1177.855 1285)",
    fill: "#E5F4F7",
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Atoms_Icons_Arrow_Down_Active",
    "data-name": "Atoms/ Icons/ Arrow Down Active",
    transform: "translate(1192.1 1296) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8,0,4,4,0,0",
    fill: "none",
    stroke: "#0099B7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/ArrowPrev.4a09505d36890d68fc1c5832e41cc68c.svg";
export { ForwardRef as ReactComponent };